import React from 'react';
import { Sparkle } from './Sparkle';
import { images } from '../data/content';
export function ProductIntro() {
  return <section aria-labelledby="intro-title" className="bg-kraft-light" data-id="element-122" data-mp="22mgi53r1gwbx">
      <div className="mx-auto grid max-w-6xl items-center gap-4 px-5 py-12 md:grid-cols-2 md:gap-10 lg:py-24" data-id="element-123" data-mp="1noo1g89ra1w5">
        <img src={images.cover} alt="Portada del Diario de Prioridad en cuaderno kraft con espiral" className="mx-auto -my-6 w-full max-w-[17rem] mix-blend-multiply sm:my-0 sm:max-w-sm md:order-2 md:max-w-md" data-id="element-124" data-mp="1smftd2aeho0c" />
        <div className="md:order-1" data-id="element-125" data-mp="2lav5nh25ds7z">
          <p className="font-display text-lg font-medium italic text-kraft-dark" data-id="element-126" data-mp="2ldzewsugze5i">Así que te presento</p>
          <h2 id="intro-title" className="mt-2 flex flex-wrap items-center gap-3 font-display text-[2.5rem] font-black leading-none tracking-tight sm:text-6xl" data-id="element-127" data-mp="26l61dcyrd83h">
            <Sparkle className="h-7 w-7" data-id="element-128" data-mp="2zaw5qual8vme" />
            El Diario de Prioridad
          </h2>
          <p className="mt-6 text-xl font-medium leading-relaxed text-ink" data-id="element-129" data-mp="343fsohv6133v">
            El método simple para organizar tu vida sin estrés, enfocarte en lo que realmente importa y dejar de
            ponerte en último lugar. Para siempre.
          </p>
          <div className="mt-8 border-l-4 border-ink pl-5" data-id="element-130" data-mp="145hzhpdnsrjq">
            <p className="font-display text-lg font-extrabold" data-id="element-131" data-mp="1471hbkeyranm">No es un diario bonito para tenerlo en el cajón.</p>
            <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-132" data-mp="zdgoe6s896va">
              Es una herramienta de acción real, diseñada para que cada día sepas exactamente qué importa, qué
              puedes soltar y cómo avanzar sin agobiarte.
            </p>
          </div>
        </div>
      </div>
    </section>;
}